import { NavLink } from "react-router-dom";
import {
  SquaresFour, FolderOpen, ChartBar, ListChecks, ChartLineUp, Buildings, Gear,
} from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";
import { DEPARTMENTS } from "@/constants";

export const navItems = [
  { to: "/", label: "Dashboard", icon: SquaresFour },
  { to: "/projects", label: "Projects", icon: FolderOpen },
  { to: "/gantt", label: "Gantt Chart", icon: ChartBar },
  { to: "/tasks", label: "Tasks", icon: ListChecks },
  { to: "/reports", label: "Reports", icon: ChartLineUp },
];

export const Sidebar = () => {
  const { user } = useAuth();
  return (
    <aside className="w-60 shrink-0 border-r border-border bg-card sticky top-16 hidden md:flex flex-col" style={{ height: "calc(100vh - 4rem)" }} data-testid="sidebar">
      <nav className="flex-1 py-4 space-y-1 overflow-y-auto">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            data-testid={`nav-link-${item.label.toLowerCase().replace(/\s/g, "-")}`}
            className={({ isActive }) => `side-link mx-2 ${isActive ? "active" : ""}`}
            end={item.to === "/"}
          >
            <item.icon size={18} weight="regular" />
            {item.label}
          </NavLink>
        ))}
        <div className="px-5 pt-4 pb-1 label-caps text-[10px]">Departments</div>
        {DEPARTMENTS.map((dept) => (
          <NavLink
            key={dept}
            to={`/departments/${encodeURIComponent(dept)}`}
            data-testid={`nav-link-dept-${dept.toLowerCase().replace(/\s/g, "-")}`}
            className={({ isActive }) => `side-link mx-2 ${isActive ? "active" : ""}`}
          >
            <Buildings size={16} weight="regular" />
            {dept}
          </NavLink>
        ))}
        {user?.role === "admin" && (
          <>
            <div className="px-5 pt-4 pb-1 label-caps text-[10px]">Admin</div>
            <NavLink
              to="/settings"
              data-testid="nav-link-settings"
              className={({ isActive }) => `side-link mx-2 ${isActive ? "active" : ""}`}
            >
              <Gear size={18} weight="regular" />
              Settings
            </NavLink>
          </>
        )}
      </nav>
      <div className="px-5 py-3 border-t border-border">
        <div className="text-[10px] font-mono text-muted-foreground" data-testid="sidebar-company-footer">© 2026 Radish Technologies</div>
      </div>
    </aside>
  );
};
